<template>
  <div
    class="el-step"
    :style="style"
    :class="[
      !isSimple && `is-${$parent.direction}`,
      isSimple && 'is-simple',
      isLast && !space && !isCenter && 'is-flex',
      isCenter && !isVertical && !isSimple && 'is-center'
     ]">
    <!-- icon & line -->
    <div
      class="el-step__head"
      :class="`is-${currentStatus}`">
      <div
        class="el-step__line"
        :style="isLast ? '' : { marginRight: $parent.stepOffset + 'px' }"
      >
        <em class="el-step__line-inner" :style="lineStyle"></em>
      </div>

      <div class="el-step__icon is-text" :class="`is-${textBackground}`">
        <slot
          v-if="currentStatus !== 'success' && currentStatus !== 'error'"
          name="icon">
          <em v-if="icon" class="el-step__icon-inner" :class="[icon]"></em>
          <div class="el-step__icon-inner" v-if="!icon && !isSimple">{{ index + 1 }}</div>
        </slot>
        <em
          v-else
          :class="['el-icon-' + (currentStatus === 'success' ? 'check' : 'close')]"
          class="el-step__icon-inner is-status"
        >
        </em>
      </div>
    </div>
    <!-- title & description -->
    <div class="el-step__main">
      <div
        class="el-step__title"
        ref="title"
        :class="['is-' + currentStatus]">
        <slot name="title">{{ title }}</slot>
      </div>
      <div v-if="isSimple" class="el-step__arrow"></div>
      <div
        v-else
        class="el-step__description"
        :class="['is-' + currentStatus]">
        <slot name="description">{{ description }}</slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElStep',

  props: {
    title: String,
    icon: String,
    description: String,
    status: String
  },

  data () {
    return {
      index: -1,
      lineStyle: {},
      internalStatus: '',
      textBackground: ''
    }
  },

  beforeCreate () {
    this.$parent.steps.push(this)
  },

  beforeDestroy () {
    const steps = this.$parent.steps
    const index = steps.indexOf(this)
    if (index && index >= 0) {
      steps.splice(index, 1)
    }
  },

  computed: {
    currentStatus () {
      return this.status || this.internalStatus
    },
    prevStatus () {
      const prevStep = this.$parent.steps[this.index - 1]
      return prevStep ? prevStep.currentStatus : 'wait'
    },
    isCenter () {
      return this.$parent.alignCenter
    },
    isVertical () {
      return this.$parent.direction === 'vertical'
    },
    isSimple () {
      return this.$parent.simple
    },
    isLast () {
      const parent = this.$parent
      return parent.steps[parent.steps.length - 1] === this
    },
    stepsCount () {
      return this.$parent.steps.length
    },
    space () {
      const { isSimple, $parent: { space } } = this
      return isSimple ? '' : space
    },
    style: function () {
      const style = {}
      const parent = this.$parent
      const len = parent.steps.length

      const space = (typeof this.space === 'number'
        ? this.space + 'px'
        : this.space
          ? this.space
          : 100 / (len - (this.isCenter ? 0 : 1)) + '%')
      style.flexBasis = space
      if (this.isVertical) return style
      if (this.isLast) {
        style.maxWidth = 100 / this.stepsCount + '%'
      } else {
        style.marginRight = -this.$parent.stepOffset + 'px'
      }

      return style
    }
  },

  methods: {
    updateStatus (val) {
      // 当前状态为第一个圈时 查看时候
      if (this.$parent.stepsShow) {
        const prevChild = this.$parent.$children[this.index - 1]
        // 小于当前步骤时
        if (val > this.index) {
          this.internalStatus = 'wait2Save'
          this.textBackground = 'blueBackground'
        } else if (val === this.index && this.prevStatus !== 'error') {
          // 等于当前步骤时
          this.internalStatus = 'processSave'
          this.textBackground = 'indexBackground'
        } else {
          // 大于当前步骤时
          this.internalStatus = 'wait2Save'
          this.textBackground = 'blueBackground'
        }
        if (prevChild) prevChild.calcProgress(this.internalStatus)
      } else if (val === 0) {
        // 第一个圈 新增时
        const prevChild = this.$parent.$children[this.index - 1]
        // 小于当前步骤时
        if (val > this.index) {
          this.internalStatus = this.$parent.finishStatus
        } else if (val === this.index && this.prevStatus !== 'error') {
        // 等于当前步骤时
          this.internalStatus = this.$parent.processStatus
          this.textBackground = 'indexBackground'
        } else {
        // 大于当前步骤时
          this.internalStatus = 'wait2'
          this.textBackground = 'textBackground'
        }
        if (prevChild) prevChild.calcProgress(this.internalStatus)
      } else {
        // 其他圈时
        const prevChild = this.$parent.$children[this.index - 1]
        // 小于当前步骤时
        if (val > this.index) {
          this.internalStatus = 'wait2Save'
          this.textBackground = 'blueBackground'
        } else if (val === this.index && this.prevStatus !== 'error') {
          // 等于当前步骤时
          // this.internalStatus = this.$parent.processStatus
          this.internalStatus = 'processSave'
          this.textBackground = 'indexBackground'
        } else {
          // 大于当前步骤时
          this.internalStatus = 'wait2Save'
          this.textBackground = 'blueBackground'
        }
        if (prevChild) prevChild.calcProgress(this.internalStatus)
      }
    },

    calcProgress (status) {
      let step = 100
      const style = {}

      style.transitionDelay = 150 * this.index + 'ms'
      if (status === this.$parent.processStatus) {
        //step = this.currentStatus !== 'error' ? 0 : 0
        step = 0
      } else if (status === 'wait') {
        step = 0
        style.transitionDelay = (-150 * this.index) + 'ms'
      }

      style.borderWidth = step && !this.isSimple ? '1px' : 0
      this.$parent.direction === 'vertical'
        ? style.height = step + '%'
        : style.width = step + '%'

      this.lineStyle = style
    },
    stepsShow (val) {
      // 第一页保存后调用此方法重新渲染圈圈颜色
      if (val) {
        const prevChild = this.$parent.$children[this.index - 1]
        // 小于当前步骤时
        if (this.$parent.active > this.index) {
          this.internalStatus = 'wait2Save'
          this.textBackground = 'blueBackground'
        } else if (this.$parent.active === this.index && this.prevStatus !== 'error') {
          // 等于当前步骤时
          // this.internalStatus = this.$parent.processStatus
          this.internalStatus = 'processSave'
          this.textBackground = 'indexBackground'
        } else {
          // 大于当前步骤时
          this.internalStatus = 'wait2Save'
          this.textBackground = 'blueBackground'
        }
        if (prevChild) prevChild.calcProgress(this.internalStatus)
      } else {
        // 第一个圈 新增时
        const prevChild = this.$parent.$children[this.index - 1]
        // 小于当前步骤时
        if (this.index === 0 && this.prevStatus !== 'error') {
          // 等于当前步骤时
          this.internalStatus = this.$parent.processStatus
          this.textBackground = 'indexBackground'
        } else {
          // 大于当前步骤时
          this.internalStatus = 'wait2'
          this.textBackground = 'textBackground'
        }
        if (prevChild) prevChild.calcProgress(this.internalStatus)
      }
    }
  },

  mounted () {
    const unwatch = this.$watch('index', val => {
      this.$watch('$parent.stepsShow', this.stepsShow, { immediate: true })
      this.$watch('$parent.active', this.updateStatus, { immediate: true })
      this.$watch('$parent.processStatus', () => {
        const activeIndex = this.$parent.active
        this.updateStatus(activeIndex)
      }, { immediate: true })
      unwatch()
    })
  }
}
</script>
<style lang='scss'  scoped>
  .el-step.is-horizontal .el-step__line {
    top: 22px;
  }
  .el-step__icon {
    position: relative;
    z-index: 1;
    display: inline-flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    width: 48px;
    height: 48px;
    font-size: 14px;
    box-sizing: border-box;
    transition: all 0s ease-out 0s;
  }
  .el-step__line-inner {
    transition: 0s ease-out;
  }

  .el-step__title.is-process {
    font-weight: 700;
    color: #fdb214;
  }
  .el-step__head.is-process {
    color: #ffffff;
    border-color: #c4c4c4;
  }
  .el-step__head.is-wait2 {
    color: #ffffff;
    border-color: #c4c4c4;
  }
  .is-textBackground {
    background: #c4c4c4
  }
  .is-indexBackground {
    background: #fdb214
  }
  .el-step__icon.is-text {
    border-radius: 50%;
    border: 2px solid;
  }
  .el-step__title.is-wait2 {
    color: #c4c4c4;
  }
  .is-blueBackground {
    background: #2f9fc6
  }
  .el-step__head.is-processSave {
    color: #ffffff;
    border-color: #2f9fc6;
  }
  .el-step__head.is-wait2Save {
    color: #ffffff;
    border-color: #2f9fc6;
  }
  .el-step__title.is-processSave {
    font-weight: 700;
    color: #fdb214;
  }
</style>
